<script>
// This mask will display with Sidebar
import { mapState } from 'vuex'
export default {
  name: 'MaskLayoutSidebar',
  computed: {
    ...mapState('app', ['sidebarMaskVisible']),
  },
}
</script>

<template>
  <div v-show="sidebarMaskVisible" class="sidebar-mask" />
</template>
